import React from 'react';
import ModalWrapper, { withOnClose } from './ModalWrapper';
import DeleteRecordingsOptions from '../DeleteRecordingsOptions';

const ModalDeleteRecordings = ({ data = {}, onSuccess = null, onCancel = null }) => {

    const modalProps = {
        childrenClassName: 'modal-delete-tv-channel'
    };

    return (
        <ModalWrapper {...modalProps}>
            <DeleteRecordingsOptions
                data={data}
                onSuccess={onSuccess}
                onCancel={onCancel}
            />
        </ModalWrapper>
    );
};

export default withOnClose(ModalDeleteRecordings);



// WEBPACK FOOTER //
// ./src/components/Modal/ModalDeleteRecordings.jsx